module.exports = __webpack_public_path__ + "static/img/19.4deeab38.jpg";